import Phaser, { Scene } from 'phaser'
import { SCENE_PARAMETERS } from './../constants/game-constants'
import {
  ENVIRONMENT_ELEMENTS_FLUJO,
  GOUT_ELEMENTS,
} from './../constants/assets-constants'
import { seconds2StringFormat } from '../utils/functions'

export default class GameFlujo extends Scene {
  constructor() {
    super({
      key: 'flujo',
      type: Phaser.AUTO,
      physics: {
        default: 'arcade',
        arcade: {
          debug: false,
          gravity: { x: 0, y: SCENE_PARAMETERS.FLUJO.GRAVITY },
        },
      },
    })
  }

  // PREPARE data and default configs
  init(props) {
    this.props = props
    this.data.set('points', 0)
    this.data.set('time', SCENE_PARAMETERS.FLUJO.TIME_LIMIT)
    this.data.set('leftKeyPress', false)
    this.data.set('rightKeyPress', false)
  }

  // LOAD assets
  preload() {
    Object.keys(ENVIRONMENT_ELEMENTS_FLUJO).map(elementKey => {
      this.load.image(elementKey, ENVIRONMENT_ELEMENTS_FLUJO[elementKey])
    })
    Object.keys(GOUT_ELEMENTS).map(elementKey => {
      this.load.image(elementKey, GOUT_ELEMENTS[elementKey])
    })
  }

  // ADD assets
  create() {
    this.addUIElements()
    this.addPersonaje()
    this.addInputPlay()
    this.addSceneElements()
    // window._scene = this
  }

  // RELOADS data on frames changes
  update() {
    if (this.physics.world.isPaused) return

    if (this.data.list.time < 1) {
      this.scene.stop()
      this.props.endScene({ name: 'flujo', points: this.data.list.points })
    }

    // UPDATE LABELS
    this.ui_clock_label.setText(seconds2StringFormat(this.data.list.time))
    this.ui_points_label.setText(this.data.list.points)

    // PERSONAJE MOVEMENT
    const PERSONAJE_VELOCITY_PERCENT = this.props.isMobile ? 0.4 : 0.3
    const DIR_MOVEMENT =
      0 +
      (this.data.list.leftKeyPress ? -1 : 0) +
      (this.data.list.rightKeyPress ? 1 : 0)
    this.f_personaje.setVelocityX(
      this.sys.canvas.width * PERSONAJE_VELOCITY_PERCENT * DIR_MOVEMENT,
    )
  }

  addUIElements() {
    let TIMER_POSITION = this.props.isMobile
      ? {
        X: this.sys.canvas.width / 2,
        Y: 30,
      }
      : {
        X: this.sys.canvas.width - 15,
        Y: 5,
      }

    const [ui_clock_text, ui_clock_icon, ui_clock_label] = this.addUIElement(
      TIMER_POSITION.X,
      TIMER_POSITION.Y,
      'TIEMPO',
      'f_clock',
      seconds2StringFormat(this.data.list.time),
    )
    this.ui_clock_text = ui_clock_text
    this.ui_clock_icon = ui_clock_icon
    this.ui_clock_label = ui_clock_label

    let POINTS_POSITION = this.props.isMobile
      ? {
        X: this.sys.canvas.width / 2 + 110,
        Y: 30,
      }
      : {
        X: this.sys.canvas.width - 10,
        Y: 70,
      }
    const [ui_points_text, ui_points_icon, ui_points_label] = this.addUIElement(
      POINTS_POSITION.X,
      POINTS_POSITION.Y,
      'PUNTOS',
      'f_star',
      this.data.list.points,
    )
    this.ui_points_text = ui_points_text
    this.ui_points_icon = ui_points_icon
    this.ui_points_label = ui_points_label
  }

  addSceneElements() {


    this.nube_base_game = this.physics.add
      .staticImage(
        this.sys.canvas.width / 2,
        this.props.isMobile ? this.sys.canvas.height + 20 : this.sys.canvas.height + 210,
        'nube_base_game',
      )
      .setScale(this.props.isMobile ? 0.43 : 0.8)
      .setOrigin(0.5, 1)
      .setDepth(1)
      .refreshBody()

  }

  addGoutsGenerator() {
    this.gouts_group = this.physics.add
      .group({
        key: 'gouts_group',
      })
      .setVisible(false)

    let colliderGoutsPosition = {
      X: this.sys.canvas.width / 2,
      Y: this.props.isMobile ? this.sys.canvas.height * 0.82 : this.sys.canvas.height * 0.86,

    }
    this.colliderGouts = this.physics.add
      .staticImage(colliderGoutsPosition.X, colliderGoutsPosition.Y, 'empty')
      .setOrigin(0.5, 0)
      .setSize(this.sys.canvas.width * 0.9, 10)
      .setVisible(false)

    this.addGoutElement()
    this.goutEventGenerator = this.time.addEvent({
      delay: SCENE_PARAMETERS.FLUJO.GOUTS_ADD_FRECUENCE,
      callback: this.addGoutElement,
      callbackScope: this,
      loop: true,
    })
  }

  addPersonaje() {
    this.f_personaje = this.physics.add
      .image(
        this.sys.canvas.width / 2,
        this.props.isMobile ? this.sys.canvas.height * 0.82 : this.sys.canvas.height * 0.85,

        'f_personaje',
      )
      .setAccelerationY(SCENE_PARAMETERS.FLUJO.GRAVITY * -1)
      .setImmovable(true)
      .setOrigin(0.5, 1)
      .setScale(this.props.isMobile ? 0.3 : 0.4)
      .setBodySize(this.props.isMobile ? 230 : 300, 10)
      .setDepth(2)

    this.f_personaje.setCollideWorldBounds(true)
  }

  addCollitionsEvent() {
    this.physics.add.collider(
      this.colliderGouts,
      this.gouts_group,
      (collider, element) => {
        if (this.data.list.points > 0)
          this.data.set(
            'points',
            this.data.list.points - SCENE_PARAMETERS.FLUJO.POINTS_TO_ACTION,
          )
        this.addPopUpPointsRemove(element)
        element.destroy()
      },
    )
    this.physics.add.collider(
      this.f_personaje,
      this.gouts_group,
      (personaje, element) => {
        console.log(element.texture.key)
        if(element.texture.key ===  'bonus'){
          this.data.set(
            'points',
            this.data.list.points + SCENE_PARAMETERS.FLUJO.POINTS_TO_BONUS,
          )
          this.addPopUpPointsBonus()

        }else{
          this.data.set(
            'points',
            this.data.list.points + SCENE_PARAMETERS.FLUJO.POINTS_TO_ACTION,
          )
          this.addPopUpPointsPlus()

        }

        element.destroy()
      },
    )
  }

  addEventTimer() {
    this.e_timerEvent = this.time.addEvent({
      delay: 1000,
      callback: this.decrementTimer,
      callbackScope: this,
      loop: true,
    })
  }

  addInputKeyboard() {
    const leftEvent = function() {
      this.data.set('leftKeyPress', true)
    }
    const leftEventOut = function() {
      this.data.set('leftKeyPress', false)
    }
    const rightEvent = function() {
      this.data.set('rightKeyPress', true)
    }
    const rightEventOut = function() {
      this.data.set('rightKeyPress', false)
    }
    if (this.props.isMobile) {
      // TOUCH BTN INPUT
      const BTN_MARGIN_HORIZONTAL = 50
      const BTN_MARGIN_VERTICAL = this.sys.canvas.height - 150

      // ADD btns
      this.inputBtnLeft = this.add
        .sprite(BTN_MARGIN_HORIZONTAL, BTN_MARGIN_VERTICAL, 'btnArrow')
        .setInteractive()
        .setRotation((-90 * Math.PI) / 180)
        .setScale(0.7)
        .setDepth(5)

      this.inputBtnRight = this.add
        .image(
          this.sys.canvas.width - BTN_MARGIN_HORIZONTAL,
          BTN_MARGIN_VERTICAL,
          'btnArrow',
        )
        .setInteractive()
        .setRotation((90 * Math.PI) / 180)
        .setScale(0.7)
        .setDepth(5)

      // BTN Events
      this.inputBtnLeft.on('pointerdown', leftEvent, this)
      this.inputBtnLeft.on('pointerout', leftEventOut, this)
      this.inputBtnLeft.on('pointerup', leftEventOut, this)

      this.inputBtnRight.on('pointerdown', rightEvent, this)
      this.inputBtnRight.on('pointerout', rightEventOut, this)
      this.inputBtnRight.on('pointerup', rightEventOut, this)
    } else {
      // KEYBOARD INPUT
      this.inputKeys = this.input.keyboard.createCursorKeys()
      this.inputKeys.left.on('down', leftEvent, this)
      this.inputKeys.left.on('up', leftEventOut, this)
      this.inputKeys.right.on('down', rightEvent, this)
      this.inputKeys.right.on('up', rightEventOut, this)
    }
  }

  addInputPlay() {
    this.physics.pause()
    let btnPlay = this.add
      .image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, 'play')
      .setInteractive()
      .setScale(this.props.isMobile ? 0.45 : 1)
    btnPlay.on(
      'pointerdown',
      () => {
        if (sessionStorage.getItem("F_DESAFIO_GAME_MODAL_IS_OPEN") === "true")
          return
        this.addGoutsGenerator()
        this.addCollitionsEvent()
        this.addInputKeyboard()
        this.addEventTimer()
        this.physics.resume()
        btnPlay.destroy()
      },
      this,
    )
  }

  // #### Functions

  decrementTimer() {
    const currentTime = this.data.list.time
    if (currentTime > 0) {
      this.data.set('time', currentTime - 1)
    } else {
      this.data.set('time', 0)
    }
  }

  addUIElement(
    _X = 0,
    _Y = 0,
    _TEXT = '----',
    _ICON = 'f_clock',
    _INITIAL_VALUE = '-- --',
  ) {
    const ui_text = this.add
      .text(
        this.props.isMobile ? _X : _X,
        this.props.isMobile ? _Y : _Y,
        _TEXT,
        {
          fontFamily: "BwModelica-Medium",
          color: '#FFFFFF',
          fontSize: this.props.isMobile ? '16px' : '22px',
          align: 'center',
        },
      )
      .setOrigin(1, 0)
      .setDepth(5)

    const ui_icon = this.add
      .image(ui_text.x - ui_text.width - 5, ui_text.y, _ICON)
      .setOrigin(1, 0.1)
      .setScale(this.props.isMobile ? 0.7 : 1)
      .setDepth(5)

    const ui_data_label = this.add
      .text(
        this.props.isMobile
          ? _X - ui_text.width / 2 - 10
          : _X - ui_text.width / 2,
        this.props.isMobile ? _Y + 15 : _Y + 25,
        _INITIAL_VALUE,
        {
          fontFamily: "BwModelica-Bold",
          color: '#FFFFFF',
          fontSize: this.props.isMobile ? '28px' : '30px',
          align: 'center',
        },
      )
      .setOrigin(0.5, 0)
      .setDepth(5)

    return [ui_text, ui_icon, ui_data_label]
  }

  addGoutElement() {
    this.gouts_group
      .create(
        Phaser.Math.Between(
          this.sys.canvas.width * 0.2,
          this.sys.canvas.width * 0.8,
        ),
        0,
        Phaser.Math.RND.pick(Object.keys(GOUT_ELEMENTS)),
      )
      .setOrigin(0.5, 1)
      .setScale(0.7)
      .setDepth(3)
      .setAccelerationY(
        SCENE_PARAMETERS.FLUJO.GRAVITY * Phaser.Math.FloatBetween(0, 0.8),
      )
  }

  addPopUpPointsRemove(_element) {
    const POP_UP_POSITION = {
      X: _element.body.x + _element.body.width / 2,
      Y: this.props.isMobile ? this.sys.canvas.height * 0.82 : this.sys.canvas.height * 0.86,
    }
    let points = this.add
      .image(POP_UP_POSITION.X, POP_UP_POSITION.Y, 'minusPoints')
      .setScale(0.4)
      .setDepth(4)
    this.add.tween({
      targets: points,
      alpha: { from: 1, to: 0 },
      ease: 'Linear',
      duration: 500,
      repeat: 0, // -1: infinity
      yoyo: false,
    })
    setTimeout(() => {
      try {
        points.destroy()
      } catch (error) {
        console.log(error)
      }
    }, 1000)
  }

  addPopUpPointsPlus() {
    const POP_UP_POSITION = {
      X: this.f_personaje.body.x + this.f_personaje.body.width / 2,
      Y: this.f_personaje.body.y + this.f_personaje.body.height / 2,
    }
    let points = this.add
      .image(POP_UP_POSITION.X, POP_UP_POSITION.Y, 'plusPoints')
      .setScale(0.4)
      .setDepth(4)
    this.add.tween({
      targets: points,
      alpha: { from: 1, to: 0 },
      ease: 'Linear',
      duration: 500,
      repeat: 0, // -1: infinity
      yoyo: false,
    })
    setTimeout(() => {
      try {
        points.destroy()
      } catch (error) {
        console.log(error)
      }
    }, 1000)
  }

  addPopUpPointsBonus() {
    const POP_UP_POSITION = {
      X: this.f_personaje.body.x + this.f_personaje.body.width / 2,
      Y: this.f_personaje.body.y + this.f_personaje.body.height / 2,
    }
    let points = this.add
      .image(POP_UP_POSITION.X, POP_UP_POSITION.Y, 'bonusPoints')
      .setScale(0.4)
      .setDepth(4)
    this.add.tween({
      targets: points,
      alpha: { from: 1, to: 0 },
      ease: 'Linear',
      duration: 500,
      repeat: 0, // -1: infinity
      yoyo: false,
    })
    setTimeout(() => {
      try {
        points.destroy()
      } catch (error) {
        console.log(error)
      }
    }, 1000)
  }
}
